<template>
    <div>
        <div class="dataTables_wrapper dt-bootstrap4">
            <div class="row" data-spy="scroll" data-target="#itemSP" data-offset="0">
                <div class="col-sm-12 overflow-auto">
                    <table class="table table-sm table-hover table-bordered table-striped w-100 dataTable dtr-inline" role="grid" style="height: 1px">
                        <thead class="thead-themed">
                            <tr>
                                <th v-for="tblHeader in fields" :key="tblHeader.key">{{tblHeader.label}}</th>
                            </tr>
                        </thead>
                        <tbody v-for="(items, date, i ) in paymentItems" :key="i">
                            <tr class="dtrg-group dtrg-start">
                                <td colspan="2" class="text-capitalize fw-700 border-top-bottom-2">
                                    <span class="text-secondary mr-2"><i class="fas fa-calendar-alt"></i></span>{{date}}
                                </td>
                                <td class="fw-500 border-top-bottom-2">
                                    <span class="badge badge-primary">{{getPaymentTotal(items)}}</span>
                                </td>
                            </tr>
                            <tr v-if="Object.keys(items).length == 0">
                                <td class="pt-2 pb-2" colspan="3"><span class="p-1 bg-warning-500 text-dark fw-500">{{$t('table.no_records')}}</span></td>
                            </tr>
                            <tr v-for="(item, itm, j) in items" :key="j">
                                <td>{{j+1}}</td>
                                <td class="text-capitalize">{{getPaymentTypeTitle(itm)}}</td>
                                <td>{{parseFloat(item).toFixed(2)}}</td>
                            </tr>
                        </tbody>
                        <tbody>
                            <tr>
                                <td colspan="2" class="border-top-bottom-2 text-right fw-700">{{$t('label.total')}}</td>
                                <td class="border-top-bottom-2 fw-500">{{total}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import _ from 'lodash';
import moment from 'moment'
import {calculateTotalByPaymentType, getPaymentTypeTitle, setPaymentItemsByPaymentType, setExportDataByPaymentMethod, setPaymentTotal}
 from './../../../../assets/js/dashboard/salonReport/salonReport'
import {formatDate, dateRange, reorderObject, setAYearArr, setYearArr}
from './../../../../assets/js/dashboard/utilities'
export default {
    name: 'paymentDate',
    props:{
        paymentType: {type: Array}
    },
    data(){
        return{
            filterObj: {},
            paymentItems: [],
            total: 0,
        }
    },
    computed:{
        fields(){
            return[
                {key: "index", label: "#"},
                {key: "paymentMethods", label: this.$i18n.t('table.header.payment_method')},
                {key: "total", label: this.$i18n.t('label.total')},
            ]
        }
    },
    watch:{
        "$i18n.locale"(val){
            this.setExportData(this.paymentItems, this.filterObj)
        }
    },
    methods:{
        getPaymentTypeTitle(id){
            return  getPaymentTypeTitle(parseInt(id), this.paymentType)
        },
        getPaymentTotal(item){
            var total = 0
            for(var k in item){
                total += item[k]
            }
            return parseFloat(total).toFixed(2)
        },
        async setPaymentItem(res, filterObj){
            var result = res.slice()
            this.total = parseFloat(calculateTotalByPaymentType(res)).toFixed(2)
            this.$parent.totalPayment = this.total

            const range = dateRange(filterObj.date.startDate, filterObj.date.endDate);
            if(range.length < 365){
                var rangeArr = range.map(date => moment(date).format(this.$msg.CST.DATE_FORMAT))
                for(var i=0; i<result.length; i++){
                    result[i]["formatDate"] = formatDate(result[i].createDate)
                }
                var group = _.groupBy(result, "formatDate")
                for(var j=0; j<rangeArr.length; j++){
                    if(!(rangeArr[j] in group)){
                        group[rangeArr[j]] = []
                    }
                }
                var reordered = reorderObject(group)             
                for(var k in reordered){
                    reordered[k] = _.groupBy(reordered[k], "paymentTypeID")
                }

                if(filterObj.paymentType != 'current'){
                    reordered = setPaymentItemsByPaymentType(reordered, filterObj.paymentMethod)
                }

                for(var r in reordered){
                    var items = reordered[r]
                    for(var p in items){
                        items[p] = calculateTotalByPaymentType(items[p])
                    }
                }
                this.paymentItems = reordered
            }else if(range.length == 366 || range.length == 365){
                var yearObj = setAYearArr(parseInt(moment(filterObj.date.startDate).format('YYYY')))
                var index = 0
                for(var m in yearObj){
                    for(var l=0; l<result.length; l++){
                        var createDate = new Date(result[l].createDate*1000);
                        if(createDate.getMonth() == index){
                            yearObj[m].push(result[l])
                        }
                    }
                    index++;
                }
                for(var y in yearObj){
                    yearObj[y] = _.groupBy(yearObj[y], "paymentTypeID")
                }

                if(filterObj.paymentType != 'current'){
                    yearObj = setPaymentItemsByPaymentType(yearObj, filterObj.paymentMethod)
                }

                for(var re in yearObj){
                    var item = yearObj[re]
                    for(var o in item){
                        item[o] = calculateTotalByPaymentType(item[o])
                    }
                }
                this.paymentItems = yearObj
            }
            else{
                var yearsObj = setYearArr(parseInt(moment(filterObj.date.startDate).format('YYYY')), parseInt(moment(filterObj.date.endDate).format('YYYY')))
                for(var yr in yearsObj){
                    for(var x=0; x<result.length; x++){
                        var cDate = new Date(result[x].createDate*1000);
                        if(cDate.getFullYear() == yr){
                            yearsObj[yr].push(result[x])
                        }
                    }
                }
                for(var yrs in yearsObj){
                    yearsObj[yrs] = _.groupBy(yearsObj[yrs], "paymentTypeID")
                }

                if(filterObj.paymentType != 'current'){
                    yearsObj = setPaymentItemsByPaymentType(yearsObj, filterObj.paymentMethod)
                }

                for(var obj in yearsObj){
                    var itm = yearsObj[obj]
                    for(var q in itm){
                        itm[q] = calculateTotalByPaymentType(itm[q])
                    }
                }
                this.paymentItems = yearsObj
            }
            this.filterObj = filterObj
            this.setExportData(this.paymentItems, filterObj)
            this.setPaymentTotal(res.slice(), filterObj)
        },
        setPaymentTotal(items, filterObj){
            var group = _.groupBy(items, "paymentTypeID")
            if(filterObj.paymentType != 'current'){
                var keys = Object.keys(group)
                if(keys.length != 0){
                    for(var i=0; i<filterObj.paymentMethod.length; i++){
                        var strPaymentID = (filterObj.paymentMethod[i].paymentTypeID).toString()
                        if(keys.indexOf(strPaymentID) == -1){
                            group[strPaymentID] = [{paymentTypeID: filterObj.paymentMethod[i].paymentTypeID, amount: 0}]
                        }
                    }
                    for(var r in group){
                        const isExists = filterObj.paymentMethod.some(o=> o.paymentTypeID == parseInt(r))
                        if(!isExists){
                            delete group[r]
                        }
                    }
                    
                }
            }
            var item = setPaymentTotal(group, this.paymentType)          
            this.$emit('setPaymentTotal', item)
        },
        setExportData(group, filterObj){
            var exportData = []

            var index = 0;
            for(var k in group){
                var paymentMethod = []
                var items = group[k]
                var obj = {
                    index: index + 1,
                    date: k,
                    total: this.getPaymentTotal(items)
                }
                for(var j in items){
                    paymentMethod.push({
                        paymentTypeID: parseInt(j),
                        amount: items[j]
                    })
                }
                obj = setExportDataByPaymentMethod(obj, paymentMethod, this.paymentType)
                exportData.push(obj)
                index++;
            }

            const exportFields = {
                "#": "index",
            }
            exportFields[this.$i18n.t('table.header.date').toUpperCase()] = "date"

            for(var i=0; i<this.paymentType.length; i++){
                exportFields[this.paymentType[i].title.toUpperCase()] =  this.paymentType[i].paymentTypeID
            }

            exportFields[this.$i18n.t('label.total').toUpperCase()] = "total"
            
            var strDate = moment(filterObj.date.startDate).format(this.$msg.CST.DATE_FORMAT) + " - " + moment(filterObj.date.endDate).format(this.$msg.CST.DATE_FORMAT);
         
            let header = this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.salon_report_payment`) + "(" + this.$i18n.messages[this.$i18n.locale].tab.reportPaymentTabs[0].text + ")" + " " + strDate
            var exportHeaders = [
                this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.salon_report_payment`), 
                this.$i18n.t('table.header.date') + ": " + strDate , 
                this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24), 
                this.$i18n.t('label.outlet') + ": " + (filterObj.outlet.id == "all" ? this.$i18n.t('label.all', {'item': this.$i18n.t('label.outlet')}) : filterObj.outlet.text),
                " "];
            var exportFileName =  header.split(" ").join("_") +  this.$msg.REPORT.CSV

            var data = {
                exportData: exportData,
                exportFields: exportFields,
                exportHeaders: exportHeaders,
                exportFileName: exportFileName
            }
            this.$emit('setExportData', data)
        },
    }
}
</script>
<style scoped>
.border-top-bottom-2{
    padding-top: .75em !important;
    border-top-width:  2px !important;
    border-bottom-width:  2px !important;
}
</style>